import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Spin,
  Icon,
  Button,
  Input,
  AutoComplete,
  Select,
  Badge,
  Alert
} from 'antd';
import moment from 'moment';
const { Option } = Select;
import {
  ssrHandler,
  fetchJobs,
  sortingChange,
  sortingJobs,
  fetchActiveReportsMetaData,
  fetchActiveReports,
  fetchPaginatedActiveReports
} from '../../actions/sessionActions';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'External ID',
    key: 'id',
    width: 7
  },
  {
    title: 'Report Name',
    key: 'name',
    width: 10
  },
  {
    title: 'Enterprise',
    key: 'state',
    width: 8
  },
  {
    title: 'Courier Partner',
    key: 'courier_partner',
    width: 10
  },
  {
    title: 'Created at',
    key: 'current',
    width: 8
  },
  {
    title: 'Last Run',
    key: 'updated',
    width: 8
  },
  {
    title: 'Next run',
    key: 'server',
    width: 8
  },
  {
    title: 'Status',
    key: '',
    width: 6
  },
  {
    title: 'To Receipients',
    key: 'url',
    width: 20
  },
  {
    title: 'CC Receipients',
    key: 'url',
    width: 15
  }
];

const reportStatus = [
  { label: 'Active', value: true },
  { label: 'InActive', value: false }
];

export class ActiveReports extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    // await dispatch(fetchJobs());
  }
  constructor() {
    super();
    this.state = {
      filter: {
        reportName: '',
        reportTypes: [],
        enterpriseId: undefined,
        active: null
      }
    };
  }

  componentWillMount() {
    const { config, match } = this.props;
    if (match.path !== config.route && config.route !== '' && config.ssr) {
      // this.props.fetchActiveReports();
    }
  }

  componentDidMount() {
    this.props
      .fetchActiveReportsMetaData('enterprise,report_metadata')
      .then(() => {
        const { reportTypes } = this.props.activeReports;
        this.setState({ reportTypes: reportTypes.map(item => item.name) });
        this.props.fetchActiveReports();
      });
  }

  pagination = () => {
    const query = {};
    const { reportName, enterpriseId } = this.state.filter;
    if (reportName) {
      query.reportName = reportName;
    }
    if (enterpriseId) {
      query.enterprise = enterpriseId;
    }
    this.props.fetchPaginatedActiveReports(query);
  };

  onSelect = reportName => {
    const { filter } = this.state;
    filter.reportName = reportName;
    filter.enterpriseId = null;
    this.setState({ filter });
    this.props.fetchActiveReports({ reportName });
  };

  reset = () => {
    const { filter } = this.state;
    this.setState(
      Object.assign(filter, {
        reportName: '',
        enterpriseId: null,
        active: null
      })
    );
    this.props.fetchActiveReports();
  };

  onChange = reportName => {
    const { filter } = this.state;
    this.setState(
      Object.assign(filter, { reportName, enterpriseId: null, active: null })
    );
  };

  handleChange = (key, value) => {
    const { filter } = this.state;
    filter[key] = value;
    this.setState(Object.assign(filter, { reportName: '' }));
    this.props.fetchActiveReports({
      enterprise: filter.enterpriseId,
      active: filter.active
    });
  };

  render() {
    const { activeReports } = this.props;
    const { filter } = this.state;
    const errors =
      activeReports.reports.list.filter(item => item.hasError) || [];
    return (
      <div>
        <Row className="margin-bottom-10 view-header">
          <Col span={6}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                showSearch
                style={{ width: '96%' }}
                placeholder="Select enterprise"
                optionFilterProp="children"
                value={filter.enterpriseId ? filter.enterpriseId : undefined}
                onChange={value => this.handleChange('enterpriseId', value)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {activeReports.enterprises.map((enterprise, i) => (
                  <Option key={i} value={enterprise.id}>
                    {enterprise.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={4}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                showSearch
                style={{ width: '96%' }}
                placeholder="Select report status"
                optionFilterProp="children"
                value={filter.active !== null ? filter.active : undefined}
                onChange={value => this.handleChange('active', value)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {reportStatus.map((item, i) => (
                  <Option key={i} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={12}>
            <AutoComplete
              className="global-search"
              style={{ width: '100%' }}
              placeholder="Search report name here"
              filterOption={(inputValue, option) =>
                option.props.children
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              }
              onSelect={this.onSelect}
              value={filter.reportName}
              onChange={this.onChange}
              dataSource={activeReports.reportTypes.map(item => item.name)}
            >
              <Input
                suffix={
                  <Icon type="search" className="certain-category-icon" />
                }
              />
            </AutoComplete>
          </Col>
          <Col span="2" className="text-right">
            <Button type="primary" onClick={this.reset}>
              Reset
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="margin-bottom-10">
            {activeReports.reports.isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {activeReports.reports.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    {errors.length > 0 && (
                      <Alert
                        message="Syntax Error"
                        className="margin-bottom-10"
                        description={
                          <>
                            <div>
                              We found errors in some of the reports. Report
                              IDs: [{' '}
                              {errors.map((report, index) => (
                                <>
                                  <a
                                    key={report.id}
                                    href={`https://cp-staging2.clickpost.in/admin/reports/reportjob/${report.id}/`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    {report.id}
                                  </a>
                                  {index !== errors.length - 1 ? (
                                    <span>, </span>
                                  ) : (
                                    ''
                                  )}
                                </>
                              ))}{' '}
                              ]
                            </div>
                          </>
                        }
                        type="error"
                        showIcon
                      />
                    )}
                    <table className={`ant-table ant-table-small width-100pt`}>
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th
                              className="padding-8"
                              key={i}
                              width={`${item.width}%`}
                            >
                              {item.title}
                              {/* <Icon type="sort-ascending" /> */}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {activeReports.reports.list.map((report, i) => (
                          <tr
                            key={i}
                            className={report.hasError ? 'row-error' : ''}
                          >
                            <td className="padding-8">
                              <a
                                href={`https://cp-staging2.clickpost.in/admin/reports/reportjob/${report.id}/`}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {report.id}
                              </a>
                            </td>
                            <td className="padding-8">{report.report_name}</td>
                            <td className="padding-8">
                              {report.enterprise_user__name}
                            </td>
                            <td className="padding-8">
                              {report.courier_partner__name}
                            </td>
                            <td className="padding-8">
                              {moment(new Date(report.created_at)).format(
                                'Do MMM YY hh:mm a'
                              )}
                            </td>
                            <td className="padding-8">
                              {moment(
                                new Date(report.last_run_timestamp)
                              ).format('Do MMM YY hh:mm a')}
                            </td>
                            <td className="padding-8">
                              {moment(
                                new Date(report.next_run_timestamp)
                              ).format('Do MMM YY hh:mm a')}
                            </td>
                            <td className="padding-8">
                              {report.enabled ? (
                                <Badge
                                  count={'Active'}
                                  style={{ backgroundColor: '#52c41a' }}
                                />
                              ) : (
                                <Badge count={'InActive'} />
                              )}
                            </td>
                            <td className="padding-8">
                              {report.email_to_list}
                            </td>
                            <td className="padding-8">
                              {report.email_cc_list}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
          {!activeReports.reports.isFetching &&
          activeReports.reports.count > activeReports.reports.list.length ? (
            <Col span={24} className="text-center">
              <Button
                type="primary"
                onClick={this.pagination}
                loading={activeReports.reports.isPaginationFetching}
                disabled={activeReports.reports.isPaginationFetching}
              >
                Load More
              </Button>
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}

ActiveReports.propTypes = {
  activeReports: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  fetchJobs: PropTypes.func,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchActiveReports: PropTypes.func,
  sortingChange: PropTypes.func,
  sortingJobs: PropTypes.func,
  fetchPaginatedActiveReports: PropTypes.func
};

ActiveReports.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  jobs: state.session.jobs,
  activeReports: state.session.activeReports
});

const mapDispatchToProps = dispatch => ({
  fetchJobs: () => dispatch(fetchJobs()),
  sortingChange: query => dispatch(sortingChange(query)),
  sortingJobs: () => dispatch(sortingJobs()),
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query)),
  fetchActiveReports: query => dispatch(fetchActiveReports(query)),
  fetchPaginatedActiveReports: query =>
    dispatch(fetchPaginatedActiveReports(query))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ActiveReports)
);
